import * as React from 'react';
import { DropdownItem } from 'ui/common/dropdown-menu/dropdown-menu-item';
import { ExpandableBox } from '../../../components/expandable-box';
import { FieldItem } from 'app/area/reports/types';

import type { JSX } from "react";

interface TargetFieldComponentProps {
  selectedField: FieldItem;
  onRemove: () => void;
  textRemove: string;
}

class TargetFieldComponent extends React.Component<TargetFieldComponentProps, {}> {
  private menuItemsForAggregation = (): DropdownItem[] => {
    const handleOnRemove = () => {
      this.props.onRemove();
    };
    return [{
      value: '1',
      description: this.props.textRemove,
      onClick: handleOnRemove
    }];
  };

  public render(): JSX.Element {
    const {
      selectedField
    } = this.props;

    return (<ExpandableBox title={selectedField.description}
      menuItems={this.menuItemsForAggregation()} />);
  }
}

export const TargetField = TargetFieldComponent;
